var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form-group', {
    staticClass: "collection-select",
    class: {
      'collection-select--disabled': _vm.computedDisabled
    },
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.subject.title,
      "label-for": _vm.subject.id
    }
  }, [_vm.isFetchingData ? _c('div', {
    staticClass: "collection-select__loading-wrapper"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : [_vm.presentationType === 'select' ? _c('AppSingleSelect', {
    attrs: {
      "id": _vm.subject.id,
      "options": _vm.optionsWithPlaceholder,
      "placeholder": _vm.placeholder,
      "disabled": _vm.subject.disabled,
      "has-error": _vm.validateError
    },
    on: {
      "input": _vm.handleSelectValueChanged
    },
    model: {
      value: _vm.selectedSelectValue,
      callback: function callback($$v) {
        _vm.selectedSelectValue = $$v;
      },
      expression: "selectedSelectValue"
    }
  }) : _vm._e(), _vm.presentationType === 'radio' ? _c('b-form-radio-group', {
    attrs: {
      "id": _vm.subject.id,
      "options": _vm.options,
      "disabled": _vm.subject.disabled
    },
    on: {
      "input": _vm.handleRadioValueChanged
    },
    model: {
      value: _vm.selectedRadioValue,
      callback: function callback($$v) {
        _vm.selectedRadioValue = $$v;
      },
      expression: "selectedRadioValue"
    }
  }) : _vm._e(), _vm.presentationType === 'checkbox' ? _c('b-form-checkbox-group', {
    attrs: {
      "id": _vm.subject.id
    },
    on: {
      "input": _vm.handleCheckboxValueChanged
    },
    model: {
      value: _vm.selectedCheckboxValue,
      callback: function callback($$v) {
        _vm.selectedCheckboxValue = $$v;
      },
      expression: "selectedCheckboxValue"
    }
  }, _vm._l(_vm.options, function (option, optionIndex) {
    return _c('b-form-checkbox', {
      key: optionIndex,
      attrs: {
        "value": optionIndex.toString(),
        "disabled": _vm.subject.disabled
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 1) : _vm._e()], _vm.subject.memo ? _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" " + _vm._s(_vm.subject.memo) + " ")]) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.validateError
    }
  }, [_vm._v(" 輸入的資料有誤或未填寫，請確認 ")])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }